import React from 'react'
import PageHeader from '../../components/pageHeader/PageHeader'

const TermsAndConditions = () => {
  return (
    <div>
       <PageHeader title={'Terms and Conditions'}/>
       <h1>Terms and Conditions</h1>
    </div>
  )
}

export default TermsAndConditions

